import { IMdCmFields } from "../types/AppTypes";
import { MdEnableStatusEnum } from "../types/AppEnums";

//系统标识  测试和生产主数据标识区别
export const CLIENT_APP_CODE = "scm";

export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 30000;

//API请求环境
const baseRequestUrl = {
	"DEV": "http://81.70.105.136:5010/xj-report-meal",
	// "TEST": "http://api-2.laoniuche.cn/xj-report-meal",
	"TEST": "http://117.122.241.106:5020/xj-report-meal",
	// "TEST": "https://xj-report-api.yunhaogroup.com/xj-report-meal",
	"PROD": "https://xj-report-api.yunhaogroup.com/xj-report-meal"
}

// 业务系统单据的请求环境
const baseRequestUrl1 = {
    DEV: `http://api.peijian88.cn`,
    // TEST: `http://test-api.laoniuche.cn`,
    TEST: `http://test-api-2.laoniuche.cn`,
    PROD: 'https://xj-report-api.yunhaogroup.com',
    STAGE: 'http://api.beiben88.com',
}


//根据环境变量自动获取图片查看地址
export const getBaseImgLookUrl = (md5: string) => {
    //自动选择环境
    return `${getBaseRequestUrl1()}/fsrv/fetch/${md5}?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseImgUploadUrl = () => {
    //自动选择环境
    return `${getBaseRequestUrl1()}/fsrv/upload_file?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseUploadData = () => {
    return {
        appCode: CLIENT_APP_CODE,
        fileMode: 0,
    }
}

//根据环境变量自动获取请求地址
export const getBaseRequestUrl1 = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
    return baseRequestUrl1[REACT_APP_ENV ?? 'DEV']
}

// const baseFileRequestUrl = "http://file-server.laoniuche.cn/file";
// /**
//  * 上传文件路径
//  */
// export const uploadFileUrl = `${baseFileRequestUrl}/uploadFile`;
// /**
//  * 获取文件服务器文件
//  * @param id 
//  * @returns 
//  */
// export const loadFileUrl = (id: string) => `${baseFileRequestUrl}/fetch?id=${id}`;
//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
	//自动选择环境
	//....
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD";
	return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";

//获取token
export const getToken = () => {
	return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};

//存储token
export const setToken = (token: string) => {
	sessionStorage.setItem(TOKEN_KEY, token)
};
//通用字段定义
export const defaultMdCmParam: IMdCmFields = {
	sourceApp: "",
	sourceAuthKey: "",
	branch: "",
	ver: undefined,
	enable: MdEnableStatusEnum.ENABLE,
};

export const branchDs = [
	{ label: "财务分支", value: "fms" },
	{ label: "主分支", value: "main" },
	{ label: "供应链分支", value: "scm" },
]